module.exports = __webpack_public_path__ + "img/team-mosaic-04.6b8f506d.jpg";